import type { List } from 'immutable';
import { createMigration } from './utils';

export const migrationTo9_170 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            const sceneIdToSceneGroupIdMap = {}; // holds the sceneGroupId for each sceneId
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                const sceneGroupId = map.getIn(['sceneGroups', i, 'id']);
                const sceneIds = map.getIn(['sceneGroups', i, 'sceneIds']) as List<string>;
                sceneIds.forEach(sceneId => { sceneIdToSceneGroupIdMap[sceneId] = sceneGroupId; });
            });
            map.get('slides').forEach((scene, i) => {
                const sceneId = map.getIn(['slides', i, 'id']) as string;
                const sceneGroupId = sceneIdToSceneGroupIdMap[sceneId];
                map.setIn(['slides', i, 'sceneGroupId'], sceneGroupId);
            });
        });
    },
});
